export enum TipoEstabelecimento {
	EMPRESA = 'empresa',
	LOJA = 'loja',
	MULTI_SELECAO = 'multi_selecao',
}
